import {SystemUsersState} from "@/store/user_management/system_users/types";
import {Module} from "vuex";
import {RootState} from "@/store/types";
import {actions} from "@/store/user_management/system_users/actions";
import {getters} from "@/store/user_management/system_users/getters";
import {mutations} from "@/store/user_management/system_users/mutations";

export const state: SystemUsersState = {
  systemUsers: [],
  systemPages: [],
}

export const systemUsers: Module<SystemUsersState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
